module.exports = __webpack_public_path__ + "img/Rectangle 55.7cd63215.png";